export default __webpack_public_path__ + "static/content-86563f361d5b681c43faad14da22efef.jpg";